import React, { useState, useEffect, useRef } from 'react'
import { MapContainer, TileLayer } from 'react-leaflet';
import PinDropIcon from '@mui/icons-material/PinDrop';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import telephonecall from '../../../../Assets/telephonecall.png'
import { ChevronDown, ChevronUp } from 'lucide-react';
import BackpackOutlinedIcon from '@mui/icons-material/BackpackOutlined';
import { keys } from '@mui/system';
import OLAMapsForDriverLocation from '../../../Customers/OLAMapsForDriverLocation';
import { FiDownload } from 'react-icons/fi'

const FirstCardPage = (props) => {
    const [driverChangedOnSelection, setDriverChangedOnSelection] = useState(true);
    console.log('props in first card page', props)

    function setDriverlatitudeAndLongitude(driverLatitude, driverLongitude) {
        if (props.setDriverLocation) {
            props.setDriverLocation({
                latitude: driverLatitude,
                longitude: driverLongitude,
            });
        }
    }
    const [type, setType] = useState(
        props?.accidentData?.vendorType
            ?.replace(/([a-z])([A-Z])/g, '$1 $2')
            ?.replace(/^./, (char) => char.toUpperCase())
    );

    const [isOpenDistance, setIsOpenDistance] = useState(false)
    const [gotData, setGotData] = useState(false)

    const [showFull, setShowFull] = useState(false);
    const [showFull2, setShowFull2] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [timeLeft, setTimeLeft] = useState(0);

    const containerRef = useRef(null);
    const [isTall, setIsTall] = useState(false);

    const vehicleOptions = (props.accidentData?.VendorDriverNumber || []).map((vehicleDetails, idx) => {
        const distance = props.accidentData?.fromVendorLocationToPickDistance?.[idx] ?? 'N/A';
        return {
            label: `${vehicleDetails.vehicleNo} - ${distance} km`,
            value: vehicleDetails.vehicleNo,
        };
    });

    const driverOptions = (props.accidentData?.VendorDriverNumber || []).map((vehicleDetails, idx) => {
        return {
            label: `${vehicleDetails.phone} ${vehicleDetails.driverName}`,
            value: vehicleDetails.phone,
            driverlat: vehicleDetails.latitude,
            driverlng: vehicleDetails.longitude,
        };
    });

    // FIX #2: selectedIndex is now the single source of truth for "which
    // vehicle is selected". The vehicle value is derived from it instead of
    // being tracked as a second, independently-settable piece of state that
    // could fall out of sync with selectedIndex.
    const currentVehicleValue = props.selectedIndex != null
        ? vehicleOptions[props.selectedIndex]?.value || ''
        : '';

    // FIX #3: was `[props]` — the whole props object, which the parent
    // recreates on every render (new object identity, new inline function
    // props) whether or not accidentData actually changed. That made this
    // effect (and its setGotData/re-render) fire on every parent render.
    // Depending on the actual field fixes that.
    useEffect(() => {
        if (props?.accidentData) {
            setGotData(true)
        }
    }, [props.accidentData]);

    useEffect(() => {
        if (props.onTimeUpdate) {
            props.onTimeUpdate(timeLeft);
        }
    }, [timeLeft]);

    useEffect(() => {
        const checkHeight = () => {
            if (containerRef.current) {
                const height = containerRef.current.clientHeight;
                setIsTall(height > 380);
            }
        };

        checkHeight();
        window.addEventListener('resize', checkHeight);
        return () => window.removeEventListener('resize', checkHeight);
    }, []);

    useEffect(() => {
        const assignedOn = props?.accidentData?.assignedOn;
        if (!assignedOn) return;

        const caseAssignedAt = new Date(assignedOn).getTime();
        const now = new Date().getTime();
        const timeElapsed = Math.floor((now - caseAssignedAt) / 1000);
        const totalDuration = 9000;
        const initialTimeLeft = totalDuration - timeElapsed;
        setTimeLeft(initialTimeLeft > 0 ? initialTimeLeft : 0);

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    props.setFirstPage(false);
                    props.setIsViewImage(false)
                    props.setIsRejected(false)
                    props.setResponseVehicle(props?.accidentData?.AccidentVehicleCode);

                    const firstVehicleNo = props.accidentData?.VendorDriverNumber?.[0]?.vehicleNo;
                    const firstDriverNo = [props.accidentData?.VendorDriverNumber?.[0]?.phone];

                    if (!props.responseVehicle && firstVehicleNo) {
                        props.setSelectedVendorVehicle(firstVehicleNo);
                        props.setSelectedVendorDriver(firstDriverNo);
                    }

                    props.setStopClockTimer(true)
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [props?.accidentData?.assignedOn]);

    useEffect(() => {
        const noVehiclePicked = !props.selectedVendorVehicle;
    const noDriverPicked = !props.selectedVendorDriver || !props.selectedVendorDriver[0];

    if ((noVehiclePicked || noDriverPicked) && vehicleOptions.length > 0 && driverOptions.length > 0) {
        const idx = props.selectedIndex != null && props.selectedIndex < vehicleOptions.length
            ? props.selectedIndex
            : 0;
        props.setSelectedIndex(idx);
        props.setSelectedVendorVehicle(vehicleOptions[idx].value);
        props.setSelectedVendorDriver([driverOptions[idx]?.value || '']);
    }
    }, [props.selectedIndex, vehicleOptions.length, driverOptions.length]);

    const radius = 50 / 2;
    const stroke = 2;
    const normalizedRadius = radius - stroke * 0.5;
    const circumference = 2 * Math.PI * normalizedRadius;
    const strokeDashoffset = circumference - (timeLeft / 9000) * circumference;

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };
    const toTitleCase = (input) => {
        return input
            .split(" ")
            .map(word =>
                word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : ""
            )
            .join(" ");
    }

    useEffect(() => {
        if (props.sendDataToParent) {
            props.sendDataToParent(props?.accidentData?.assignedOn);
        }
    }, [timeLeft]);

    return (
        <div className='relative  font-satoshi'>
            {gotData && (<div className='h-1/2 relative max-w-[90vw]'>
                {!isOpenDistance && (
                    <OLAMapsForDriverLocation
                        dropLatitude={props.accidentData?.dropLatitude}
                        dropLongitude={props.accidentData?.dropLongitude}
                        pickupLatitude={props.accidentData?.pickupLatitude}
                        pickupLongitude={props.accidentData?.pickupLongitude}
                        driverLatitude={props.driverLocation?.latitude ?? props.accidentData?.driverLatitude}
                        driverLongitude={props.driverLocation?.longitude ?? props.accidentData?.driverLongitude}
                        allowDriverProceed={props.accidentData?.allowDriverProceed}
                        driverChangedOnSelection={driverChangedOnSelection}
                        adjustWidth={true}
                    />
                )}

                <div className=' bg-[#2d4f5d]'>

                    {isOpenDistance && (
                        <>
                            <div className="relative font-satoshi top-0 left-0 w-full bg-[#697c9b] text-white transition-all duration-300 h-[50%] z-50">
                                <div className="p-4  bg-white text-black">
                                    <h2 className="text-sm font-semibold mb-2">Trip Details</h2>

                                    <div className="flex items-center space-x-4 mb-1">
                                        <MyLocationIcon className="text-blue-400 h-4" />
                                        <div>
                                            <h4 className="text-sm font-semibold">Vendor's Current Location</h4>
                                            <p className="text-xs">(Your Location)</p>
                                        </div>
                                    </div>

                                    <div className="relative flex items-center mb-1 ml-[6px]">
                                        <div className="w-[2px] h-12 bg-gray-300 ml-[6px]"></div>
                                        <div className="ml-4 flex flex-col justify-center">
                                            <p className="text-xs font-semibold">{props?.accidentData?.fromVendorLocationToPickDuration}</p>
                                            <p className="text-xs font-semibold">
                                                {props?.accidentData?.fromVendorLocationToPickDistance
                                                    ? `${parseFloat(props?.accidentData?.fromVendorLocationToPickDistance).toFixed(2)} Km`
                                                    : 'N/A'}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center space-x-4 mb-1">
                                        <PinDropIcon className="text-green-400 h-6" />
                                        <div>
                                            <h4 className="text-sm font-semibold">Pickup Location</h4>
                                            <p
                                                className={`text-xs cursor-pointer transition-all duration-200 ${showFull
                                                    ? 'whitespace-normal overflow-visible text-clip'
                                                    : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                    }`}
                                                onClick={() => setShowFull(!showFull)}
                                                title={props?.accidentData?.pickupLocation}
                                            >
                                                {toTitleCase(props?.accidentData?.pickupLocation)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="relative flex items-center mb-1 ml-[6px]">
                                        <div className="w-[2px] h-12 bg-gray-300 ml-[6px]"></div>
                                        <div className="ml-4 flex flex-col justify-center">
                                            <p className="text-xs font-semibold">{props?.accidentData?.fromPickToDropDuration}</p>
                                            <p className="text-xs font-semibold">
                                                {props?.accidentData?.fromPickToDropDistance
                                                    ? `${parseFloat(props?.accidentData?.fromPickToDropDistance).toFixed(2)} Km`
                                                    : 'N/A'}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center space-x-4">
                                        <PinDropIcon className="text-red-400 h-6" />
                                        <div>
                                            <h4 className="text-sm font-semibold">Drop Location</h4>
                                            <p
                                                className={`text-xs cursor-pointer transition-all duration-200 ${showFull2
                                                    ? 'whitespace-normal overflow-visible text-clip'
                                                    : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                    }`}
                                                onClick={() => setShowFull2(!showFull2)}
                                                title={props?.accidentData?.dropLocation}
                                            >
                                                {toTitleCase(props?.accidentData?.dropLocation)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <div className="bg-white z-10 relative">
                        <div className="px-1 py-1">
                            <div className="flex flex-col px-[1rem]">
                                <div
                                    className="flex justify-between items-center pr-3 cursor-pointer"
                                    onClick={() => setIsOpenDistance(!isOpenDistance)}
                                >
                                    <div className="flex items-center space-x-4 top-0 h-2">
                                        <p className="text-black text-sm font-semibold mt-1">Distance </p>
                                        <div className="flex justify-center items-center" style={{ height: 30, width: 100 }}>
                                            <div className="relative w-full h-5 rounded-full bg-[#2c2f3b]/20 overflow-hidden">
                                                <div
                                                    className="absolute top-0 left-0 h-full rounded-full bg-[#EFF9FD] transition-all duration-300"
                                                    style={{
                                                        width: `${(timeLeft / 9000) * 100}%`,
                                                    }}
                                                ></div>
                                                <div className="absolute inset-0 flex items-center justify-center">
                                                    <span className="text-[10px] font-semibold text-red-500 animate-pulse">
                                                        {formatTime(timeLeft)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center mt-1">
                                        <div className="text-xs text-black font-semibold px-1 py-1 m-1 rounded-xl">
                                            {Number(props?.accidentData?.totalDistance || 0).toFixed(1)} Km
                                        </div>
                                        {isOpenDistance ? (
                                            <ChevronUp className="text-black h-6 p-1 bg-gray-200 rounded-full" />
                                        ) : (
                                            <ChevronDown className="text-black h-6 p-1  bg-gray-200 rounded-full" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bg-white h-full p-2'>
                    <div style={{ boxShadow: '1px 1px 7px 0px' }} className='bg-[#f9f9f9] rounded-xl flex justify-between m-1 mb-3'>
                        <div className='px-2 py-2 flex-col'>
                            <div className='flex justify-center items-center text-center'>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/front-left.jpg' alt='truck image' className=' h-[2.5rem] w-[3rem]' />
                                <h4 className='text-[1rem] font-semibold mt-[0.3rem] pl-[1rem]'>{props?.accidentData?.reg} </h4>
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-xs font-semibold'>{type} Service Required</p>
                            </div>
                        </div>
                        <div className="p-1 rounded-xl border-4 border-blue-500 flex flex-col items-center justify-center">
                            {Object.keys(props.images).length > 0 && (
                                <img
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setIsModalOpen(true)}
                                    className="h-20 w-20 p-2 rounded-[20%]"
                                    src={props.images[Object.keys(props.images)[0]]}
                                    alt="crane"
                                />
                            )}
                            <p className="text-black text-xs">View Images</p>
                        </div>
                    </div>
                    {!props.isRejected && (<div>
                        <div className="flex gap-1 pb-3">
                            <hr />
                            <div className="flex flex-col w-full">
                                {vehicleOptions.map((vehicle, index) => {
                                    const isSelected = props.selectedIndex === index;
                                    const isDriverEditable = props.editableDriverIndex === index;
                                    const selectedDriverValue = props.selectedVendorDriver?.[0] || '';

                                    return (
                                        <div
                                            key={vehicle.value}
                                            style={{
                                                boxShadow: props.selectedIndex !== null && isSelected ? '2px 0px 2px' : '',
                                                border: isSelected ? '2px solid black' : '1px solid transparent',
                                                opacity: props.selectedIndex !== null && !isSelected ? 0.9 : 1,
                                                cursor: props.selectedIndex === null || isSelected ? 'pointer' : 'not-allowed',
                                            }}
                                            className="flex mt-1 gap-1 rounded-xl justify-around items-center"
                                            onClick={() => {
                                                if (!isSelected) {
                                                    props.setSelectedIndex(index);
                                                    // vehicle value is derived from selectedIndex (currentVehicleValue);
                                                    // still calling this setter for backward compatibility only.
                                                    props.setSelectedVendorVehicle(vehicle.value);
                                                    props.setSelectedVendorDriver([driverOptions[index]?.value || '']);
                                                    setDriverlatitudeAndLongitude(driverOptions[index]?.driverlat, driverOptions[index]?.driverlng);
                                                    props.setEditableDriverIndex(null);
                                                    setDriverChangedOnSelection(true);
                                                }
                                            }}
                                        >
                                            <img
                                                src={type === 'Recovery Van' ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumRecoveryVan.jpg' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg'}
                                                className="h-[2.5rem] w-[4rem] pl-[1rem]"
                                                alt="service provider"
                                            />

                                            <label htmlFor={`vehicle-${index}`} className="text-xs mt-2 mb-1 w-[130px]">
                                                <div className="flex flex-col items-center">
                                                    <p className="text-xs font-semibold mt-2">{vehicle.value}</p>
                                                    <p className="text-xs mt-1 mb-1">{vehicle.label.split('-')[1]}</p>
                                                </div>
                                            </label>

                                            <div className="flex flex-col pr-2">
                                                {isDriverEditable && (<select
                                                    id={`driver-${index}`}
                                                    className="font-satoshi w-full h-[35px] text-xs rounded-lg px-2 focus:outline-none focus:ring-2 focus:ring-[#21A6E9] transition"
                                                    value={props.selectedVendorDriver?.[0]}
                                                    onChange={(e) => {
                                                        const chosenDriver = driverOptions.find(
                                                            d => d.value === e.target.value
                                                        );
                                                        props.setSelectedVendorDriver([e.target.value]);
                                                        if (chosenDriver) {
                                                            setDriverlatitudeAndLongitude(
                                                                chosenDriver.driverlat,
                                                                chosenDriver.driverlng
                                                            );
                                                        }
                                                        setDriverChangedOnSelection(true);
                                                    }}
                                                >
                                                    <option value="">Select Driver</option>
                                                    {driverOptions.map(({ label, value }) => (
                                                        <option key={value} value={value}>
                                                            {label}
                                                        </option>
                                                    ))}
                                                </select>)}

                                                {!isDriverEditable && (
                                                    <p className="text-[12px] text-gray-600 mt-1">
                                                        {[driverOptions[index]?.value || '']}
                                                    </p>
                                                )}

                                                {isSelected && driverOptions.length > 1 && (
                                                    <p
                                                        className="underline text-[11px] text-green-800 text-end cursor-pointer"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            props.setEditableDriverIndex(index);
                                                        }}
                                                    >
                                                        Change Driver
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className='bg-white flex justify-between m-1' style={{ borderTop: '1px solid gray' }}>
                            <div className='px-2 py-1 flex-col'>
                                <div className='flex'>
                                    <MyLocationIcon className='m-1 mt-2' />
                                    <div className='px-2 py-2 flex-col'>
                                        <p
                                            className={`text-xs cursor-pointer transition-all duration-200 ${showFull
                                                ? 'whitespace-normal overflow-visible text-clip'
                                                : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                }`}
                                            onClick={() => setShowFull(!showFull)}
                                            title={props?.accidentData?.pickupLocation}
                                        >
                                            {props?.accidentData?.pickupLocation}
                                        </p>
                                        <p className='text-xs font-semibold truncate'>Vehicle Location</p>
                                    </div>
                                </div>
                                <div className='flex'>
                                    <PinDropIcon className='m-1 mt-2' />
                                    <div className='px-1 py-1 flex-col'>
                                        <p
                                            className={`text-xs cursor-pointer transition-all duration-200 ${showFull2
                                                ? 'whitespace-normal overflow-visible text-clip'
                                                : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                }`}
                                            onClick={() => setShowFull2(!showFull2)}
                                            title={props?.accidentData?.dropLocation}
                                        >
                                            {props?.accidentData?.dropLocation}
                                        </p>
                                        <h4 className='text-xs font-semibold truncate'>Drop Location </h4>
                                    </div>
                                </div>

                                {Boolean(props?.accidentData?.isMaterialLoaded) && (
                                    <div className='flex'>
                                        <BackpackOutlinedIcon className='m-1 mt-2' />
                                        <div className='px-1 py-1 flex-col'>
                                            <h4 className='text-xs font-semibold mt-2'>{props?.accidentData?.quantity} Loaded (in tons) </h4>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='px-1 py-4'>
                                <h2 className='font-semibold text-[1rem] flex'>₹ {props?.accidentData?.nonGSTCharge}</h2>
                            </div>
                        </div>

                        <div>
                            <div className='bg-white flex justify-between items-center' style={{ borderTop: '1px solid gray' }}>
                                <div
                                    ref={containerRef}
                                    className={`flex gap-2 p-2 ${isTall ? 'flex-col' : 'flex-row'}`}
                                >
                                    <button
                                        type="button"
                                        disabled={!currentVehicleValue || !props.selectedVendorDriver?.[0]}
                                        className="flex items-center justify-center gap-2 text-white text-xs font-semibold py-2 px-4 rounded-xl transition-all w-full bg-[#21A6E9] hover:bg-[#1c94d1] disabled:opacity-50 disabled:cursor-not-allowed"
                                        onClick={() => {
                                            props.setFirstPage(false);
                                            props.setIsViewImage(false);
                                            props.setIsRejected(false);
                                            props.setVendorDecision('accept');
                                            props.setResponseVehicle(props?.accidentData?.AccidentVehicleCode);

                                            if (!currentVehicleValue) {
                                                props.setSelectedVendorVehicle(props?.accidentData?.VendorDriverNumber?.[0]?.vehicleNo || '');
                                            }

                                            if (!props.selectedVendorDriver || props.selectedVendorDriver.length === 0) {
                                                props.setSelectedVendorDriver([props?.accidentData?.VendorDriverNumber?.[0]?.phone || '']);
                                            }
                                        }}
                                    >
                                        <p>Accept</p>
                                    </button>

                                    <button
                                        type="button"
                                        className="flex items-center justify-center gap-2 text-white text-xs font-semibold py-2 px-4 rounded-xl transition-all w-full bg-[#EE3840] hover:bg-[#d32f2f]"
                                        onClick={() => {
                                            props.setFirstPage(false);
                                            props.setIsAccepted(false);
                                            props.setIsViewImage(false);
                                            props.setIsRejected(true);
                                            props.setVendorDecision('reject');
                                            props.setResponseVehicle(props?.accidentData?.AccidentVehicleCode);

                                            if (!currentVehicleValue) {
                                                props.setSelectedVendorVehicle(props?.accidentData?.VendorDriverNumber?.[0]?.vehicleNo || '');
                                            }

                                            if (!props.selectedVendorDriver || props.selectedVendorDriver.length === 0) {
                                                props.setSelectedVendorDriver([props?.accidentData?.VendorDriverNumber?.[0]?.phone || '']);
                                            }
                                        }}
                                    >
                                        <p>Reject</p>
                                    </button>
                                </div>

                                <div
                                    onClick={() => (window.location.href = 'tel: +91 7800 78 4700')}
                                    className='flex flex-col items-center justify-center px-2 py-2'
                                >
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/telephonecall.png' className='h-[30px] w-[30px]' alt="call for help" />
                                </div>
                            </div>
                        </div>
                    </div>)}

                    <div className="hidden flex justify-between gap-4">
                        <button className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-6 rounded-full transition-all w-full">
                            Back
                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                        </button>

                        <button
                            className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-6 rounded-full transition-all w-full ${true
                                ? "bg-[#21A6E9] hover:bg-[#1e94d6]"
                                : "bg-[#a7dbf5] cursor-not-allowed"
                                }`}
                        >
                            Continue
                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px]" />
                        </button>
                    </div>
                </div>

                <ShowImagesModal
                    isOpen={isModalOpen}
                    images={props.images}
                    onClose={() => setIsModalOpen(false)}
                />
            </div>)}
        </div>
    )
}
export default FirstCardPage;

function ShowImagesModal({ isOpen, onClose, images }) {
    if (!isOpen) return null;

    let clickTimer = null;

    const handleImageClick = (url) => {
        if (clickTimer) {
            clearTimeout(clickTimer);
            clickTimer = null;
            handleDownload(url);
        } else {
            clickTimer = setTimeout(() => {
                clickTimer = null;
            }, 300);
        }
    };

    const handleDownload = (url) => {
        try {
            const s3Key = new URL(url).pathname.substring(1);
            const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/api/downloadVehicleImage?key=${encodeURIComponent(s3Key)}`;

            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = "";
            link.target = "_blank";
            link.rel = "noopener noreferrer";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            alert("Download failed.");
            console.error(err);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] px-2" style={{ pointerEvents: 'auto' }}>
            <div className="bg-white rounded-[24px] shadow-xl w-full max-w-[520px] h-[70vh] pt-3 md:p-6 relative animate-fadeIn flex flex-col">
                <div className="flex items-center justify-between px-4 mb-1">
                    <h6 className="text-[22px] md:text-[26px] font-semibold text-gray-800 font-satoshi">
                        Vehicle Images
                    </h6>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800 text-[18px] font-semibold"
                        title="Close"
                    >
                        ✕
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
                    {Object.entries(images).map(([label, url], index) => (
                        <div
                            key={index}
                            className="row text-center justify-content-center py-2 rounded-xl"
                            style={{ border: "3px solid grey" }}
                        >
                            <div className="flex flex-col items-center group relative">
                                <div className="relative w-full max-w-[440px]">
                                    <img
                                        src={url}
                                        alt={label}
                                        className="w-full h-64 object-cover rounded-xl shadow-md scale-105 transition-transform duration-300"
                                        onError={(e) => (e.target.src = '/fallback-image.jpg')}
                                        onClick={() => handleImageClick(url)}
                                        style={{ pointerEvents: 'auto', cursor: 'pointer' }}
                                    />
                                    <button
                                        onClick={() => handleDownload(url, label)}
                                        className="absolute top-2 right-2 bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 hidden group-hover:block transition-opacity"
                                        title="Download"
                                    >
                                        <FiDownload className="text-gray-700 text-lg" />
                                    </button>
                                </div>
                                <p className="text-sm mt-2 font-medium text-gray-600 text-center">{label}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}